"use client";

import * as React from "react";
import { Modal } from "@heroui/react";
import { trpc } from "@/lib/trpc";
import { RacDialogTriggerAnchor } from '@/components/RacDialogTriggerAnchor';

export interface PreviewMedia {
  id: string;
  name: string;
  mimeType: string;
  url: string;
}

interface AssetsPreviewDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  media: PreviewMedia | null;
}

export function AssetsPreviewDialog({ open, onOpenChange, media }: AssetsPreviewDialogProps) {
  const title = media?.name || "预览";

  const { data, isLoading, isError } = trpc.assets.getDocumentPreviewUrl.useQuery(
    { id: media?.id ?? "" },
    { enabled: open && !!media?.id }
  );

  const previewUrl = data?.url ?? null;

  const handleOpenChange = React.useCallback(
    (next: boolean) => {
      onOpenChange(next);
    },
    [onOpenChange]
  );

  return (
    <Modal isOpen={open && !!media} onOpenChange={handleOpenChange}>
      <RacDialogTriggerAnchor />
      <Modal.Backdrop>
        <Modal.Container placement="center" scroll="inside" className="max-w-[90vw]">
          <Modal.Dialog className="flex h-[85vh] max-h-[85vh] w-[90vw] max-w-[90vw] flex-col">
            <Modal.Header className="shrink-0 border-b border-divider py-3">
              <Modal.Heading className="truncate text-base font-medium">{title}</Modal.Heading>
            </Modal.Header>
            <Modal.Body className="min-h-0 flex-1 overflow-hidden p-0">
              {isLoading ? (
                <div className="text-muted-foreground flex h-full min-h-[200px] items-center justify-center text-sm">
                  加载预览中…
                </div>
              ) : null}
              {isError ? (
                <div className="text-muted-foreground flex h-full min-h-[200px] items-center justify-center text-sm">
                  预览加载失败，请下载后查看。
                </div>
              ) : null}
              {!isLoading && !isError && previewUrl ? (
                <iframe
                  src={previewUrl}
                  title={title}
                  className="h-full min-h-0 w-full flex-1 border-0 bg-muted/30"
                  allowFullScreen
                />
              ) : null}
              {!isLoading && !isError && !previewUrl ? (
                <div className="text-muted-foreground flex h-full min-h-[200px] items-center justify-center text-sm">
                  无法生成预览地址，请下载查看。
                </div>
              ) : null}
            </Modal.Body>
          </Modal.Dialog>
        </Modal.Container>
      </Modal.Backdrop>
    </Modal>
  );
}
